(function () {
  function stripExactPhraseQuotes(query) {
    if (query.length >= 2 && query.startsWith('"') && query.endsWith('"')) {
      return query.slice(1, -1);
    }

    return query;
  }

  function isProductCode(query) {
    const unquotedQuery = stripExactPhraseQuotes(query.trim());

    if (!/\d/.test(unquotedQuery)) return false;
    if (/^\d{3,}$/.test(unquotedQuery)) return true;

    return (
      /^[A-Za-z0-9#._/-]+$/.test(unquotedQuery) &&
      /[#._/-]/.test(unquotedQuery)
    );
  }

  function getOrCreateHiddenInput(form, name) {
    let input = form.querySelector(`input[name="${name}"]`);

    if (!input) {
      input = form.ownerDocument.createElement("input");
      input.type = "hidden";
      input.name = name;
      form.appendChild(input);
    }

    return input;
  }

  function normalizeSearchForm(form, hasSkuMatch = false) {
    const queryInput = form.querySelector('input[name="q"]');
    if (!queryInput) return false;

    const query = queryInput.value.trim();
    if (!isProductCode(query)) return false;

    const productCode = stripExactPhraseQuotes(query);
    queryInput.value = hasSkuMatch
      ? `variants.sku:"${productCode}"`
      : `"${productCode}"`;
    getOrCreateHiddenInput(form, "options[prefix]").value = "none";
    getOrCreateHiddenInput(form, "type").value = "product";

    return true;
  }

  function isSearchForm(form) {
    if (!form || form.tagName !== "FORM") return false;

    try {
      return new URL(form.action, window.location.origin).pathname.endsWith(
        "/search",
      );
    } catch (error) {
      return false;
    }
  }

  async function hasVariantSkuMatch(productCode) {
    const predictiveSearchPath =
      window.routes?.predictive_search_url || "/search/suggest";
    const endpoint = new URL(
      predictiveSearchPath.endsWith(".json")
        ? predictiveSearchPath
        : `${predictiveSearchPath}.json`,
      window.location.origin,
    );

    endpoint.searchParams.set("q", `"${productCode}"`);
    endpoint.searchParams.set("resources[type]", "product");
    endpoint.searchParams.set("resources[limit]", "10");
    endpoint.searchParams.set("resources[options][fields]", "variants.sku");

    try {
      const response = await fetch(endpoint);
      if (!response.ok) return false;

      const data = await response.json();
      return data.resources?.results?.products?.length > 0;
    } catch (error) {
      return false;
    }
  }

  const api = {
    isProductCode,
    normalizeSearchForm,
  };

  if (typeof module !== "undefined" && module.exports) {
    module.exports = api;
    return;
  }

  document.addEventListener(
    "submit",
    async (event) => {
      const form = event.target;
      if (!isSearchForm(form)) return;
      if (form.closest("predictive-search")?.querySelector('[aria-selected="true"] a')) return;

      const queryInput = form.querySelector('input[name="q"]');
      const productCode = queryInput?.value.trim();
      if (!productCode || !isProductCode(productCode)) return;

      event.preventDefault();
      if (form.dataset.normalizingProductCode === "true") return;
      form.dataset.normalizingProductCode = "true";

      const skuMatch = await hasVariantSkuMatch(
        stripExactPhraseQuotes(productCode),
      );
      normalizeSearchForm(form, skuMatch);
      form.submit();
    },
    true,
  );
})();
